import React from 'react'
import SectionMenu from './components/SectionMenu'

export default function Header() {
  return (
    <header className="mainHeader" id="header">
      <SectionMenu />
    </header>
  )
}
